// extracted by mini-css-extract-plugin
export default {"page":"ZQ-z","cartModal":"_Q-z","checkout":"aR-z","placeholder":"bR-z","account":"cR-z"};